import { useSelector } from "react-redux";
import { getStatements } from "../redux/slices/languageSlice";

const useLang = translationKey => {
  const lang = useSelector(state => getStatements(state));

  return translationKey ? [lang[translationKey]] : [lang];
};

export default useLang;
